import { faker } from '@faker-js/faker/locale/es';

faker.seed(123);

const marcasModelos = {
  'Seat': ['Ibiza', 'León', 'Arona', 'Ateca', 'Tarraco'],
  'Volkswagen': ['Golf', 'Polo', 'Tiguan', 'Passat', 'T-Roc'],
  'Renault': ['Clio', 'Megane', 'Captur', 'Kadjar', 'Scenic'],
  'Peugeot': ['208', '308', '2008', '3008', '5008'],
  'Citroën': ['C3', 'C4', 'C5 Aircross', 'Berlingo'],
  'Ford': ['Fiesta', 'Focus', 'Kuga', 'Puma', 'Mondeo'],
  'Opel': ['Corsa', 'Astra', 'Crossland', 'Grandland', 'Mokka'],
  'Toyota': ['Yaris', 'Corolla', 'C-HR', 'RAV4', 'Aygo'],
  'Nissan': ['Micra', 'Qashqai', 'Juke', 'X-Trail', 'Leaf'],
  'Hyundai': ['i20', 'i30', 'Tucson', 'Kona', 'Santa Fe'],
  'Kia': ['Rio', 'Ceed', 'Sportage', 'Niro', 'Sorento'],
  'BMW': ['Serie 1', 'Serie 3', 'X1', 'X3', 'X5'],
  'Mercedes-Benz': ['Clase A', 'Clase C', 'GLA', 'GLC', 'GLE'],
  'Audi': ['A3', 'A4', 'Q3', 'Q5', 'Q7']
};

const combustibles = ['Gasolina', 'Diésel', 'Híbrido', 'Eléctrico', 'GLP'];
const colores = ['Blanco', 'Negro', 'Gris', 'Plata', 'Azul', 'Rojo', 'Verde', 'Beige'];

export const generateMatricula = () => {
  const nums = faker.number.int({ min: 1000, max: 9999 });
  const letters = faker.string.alpha({ length: 3, casing: 'upper' });
  return `${nums}${letters}`;
};

export const generateBastidor = () => {
  return faker.string.alphanumeric({ length: 17, casing: 'upper' });
};

export const generateVehiculo = () => {
  const marca = faker.helpers.arrayElement(Object.keys(marcasModelos));
  const modelo = faker.helpers.arrayElement(marcasModelos[marca]);
  const year = faker.number.int({ min: 2015, max: 2024 });
  
  return {
    matricula: generateMatricula(),
    bastidor: generateBastidor(),
    marca,
    modelo,
    version: `${modelo} ${faker.helpers.arrayElement(['1.0', '1.2', '1.4', '1.6', '2.0'])} ${faker.helpers.arrayElement(['TSI', 'TDI', 'HDI', 'TFSI'])}`,
    year,
    combustible: faker.helpers.arrayElement(combustibles),
    potencia: faker.number.int({ min: 75, max: 250 }),
    cilindrada: faker.number.int({ min: 1000, max: 3000 }),
    color: faker.helpers.arrayElement(colores),
    kilometros: faker.number.int({ min: 5000, max: 200000 })
  };
};

export const generatePropietario = () => {
  const firstName = faker.person.firstName();
  const lastName = faker.person.lastName();
  const fullName = `${firstName} ${lastName}`;
  
  const dniNumber = faker.number.int({ min: 10000000, max: 99999999 });
  const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const dniLetter = letters.charAt(dniNumber % 23);
  
  return {
    nombre: fullName,
    dni: `${dniNumber}${dniLetter}`,
    telefono: `6${faker.number.int({ min: 10000000, max: 99999999 })}`,
    email: faker.internet.email({ firstName, lastName }).toLowerCase(),
    direccion: faker.location.streetAddress(),
    ciudad: faker.location.city(),
    codigoPostal: faker.location.zipCode('#####')
  };
};

export const generateGarantia = (id) => {
  const vehiculo = generateVehiculo();
  const propietario = generatePropietario();
  const nivel = faker.number.int({ min: 1, max: 4 });
  const fechaAlta = faker.date.between({
    from: new Date(2023, 0, 1),
    to: new Date()
  });
  const fechaVencimiento = new Date(fechaAlta);
  fechaVencimiento.setFullYear(fechaVencimiento.getFullYear() + 1);

  const preciosBase = [299, 499, 699, 899];
  const precioBase = preciosBase[nivel - 1];
  const costeBase = precioBase * 0.65;

  const margenVendedor = faker.number.float({ min: 1.05, max: 1.25, precision: 0.01 });
  const precioVentaPropio = Math.round(precioBase * margenVendedor);
  const rentabilidad = precioVentaPropio - costeBase;
  const porcentajeRentabilidad = ((rentabilidad / precioVentaPropio) * 100).toFixed(2);

  const vendedorEmail = faker.helpers.arrayElement(['vendedor@rdgarantia.com', 'agente@rdgarantia.com']);
  const comisionVendedor = faker.number.float({ min: 3, max: 6, precision: 0.5 });
  const comisionImporte = (precioVentaPropio * comisionVendedor / 100).toFixed(2);

  return {
    id: id || faker.string.uuid(),
    numeroGarantia: `GAR-${faker.number.int({ min: 100000, max: 999999 })}`,
    vehiculo,
    propietario,
    nivel,
    nivelNombre: ['Básica', 'Estándar', 'Premium', 'Total'][nivel - 1],
    fechaAlta: fechaAlta.toISOString(),
    fechaVencimiento: fechaVencimiento.toISOString(),
    estado: fechaVencimiento > new Date() ? 'activa' : 'finalizada',
    precioBase,
    costeBase,
    precioVentaPropio,
    rentabilidad,
    porcentajeRentabilidad: parseFloat(porcentajeRentabilidad),
    margen: precioVentaPropio - costeBase,
    vendedor: vendedorEmail,
    comisionVendedor,
    comisionImporte: parseFloat(comisionImporte),
    numeroAverias: faker.number.int({ min: 0, max: 5 }),
    firmaDigital: {
      firmado: true,
      timestamp: fechaAlta.toISOString(),
      ip: faker.internet.ipv4(),
      hash: faker.string.alphanumeric({ length: 64 }),
      metodo: faker.helpers.arrayElement(['biometrica', 'certificado_digital', 'sms_otp', 'email_confirmacion'])
    }
  };
};

export const generateAveria = (garantiaId) => {
  const estados = ['pendiente', 'en_curso', 'diagnosticada', 'autorizada', 'rechazada', 'finalizada', 'facturada'];
  const tipos = ['Motor', 'Transmisión', 'Suspensión', 'Frenos', 'Eléctrico', 'Climatización', 'Dirección'];
  const estado = faker.helpers.arrayElement(estados);
  const tipo = faker.helpers.arrayElement(tipos);
  const cubierta = faker.datatype.boolean(0.7);
  const coste = faker.number.int({ min: 150, max: 2500 });

  const fechaReporte = faker.date.recent({ days: 60 });
  let fechaAutorizacion = null;
  let autorizadoPor = null;
  let evidenciaLegal = null;
  let evidencias = [];

  if (['autorizada', 'finalizada', 'facturada'].includes(estado)) {
    fechaAutorizacion = new Date(fechaReporte);
    fechaAutorizacion.setHours(fechaAutorizacion.getHours() + faker.number.int({ min: 1, max: 48 }));
    autorizadoPor = faker.helpers.arrayElement(['admin@rdgarantia.com', 'tecnico@rdgarantia.com']);
    evidenciaLegal = {
      timestamp: fechaAutorizacion.toISOString(),
      ip: faker.internet.ipv4(),
      userAgent: faker.internet.userAgent(),
      hash: faker.string.alphanumeric({ length: 64 }),
      justificantePDF: `justificante-${faker.string.uuid()}.pdf`
    };
  }

  if (['diagnosticada', 'autorizada', 'finalizada', 'facturada'].includes(estado)) {
    const averiaId = faker.string.uuid();

    const numEvidencias = faker.number.int({ min: 2, max: 5 });
    for (let i = 0; i < numEvidencias; i++) {
      const tipoEvidencia = faker.helpers.arrayElement(['foto', 'video', 'documento']);
      evidencias.push({
        id: faker.string.uuid(),
        tipo: tipoEvidencia,
        filename: `evidencia_${i + 1}.${tipoEvidencia === 'foto' ? 'jpg' : tipoEvidencia === 'video' ? 'mp4' : 'pdf'}`,
        rutaLocal: `/uploads/evidencias/${averiaId}/evidencia_${i + 1}`,
        hash: Math.random().toString(36).substring(2),
        timestamp: new Date(fechaReporte.getTime() + (i + 1) * 1800000).toISOString()
      });
    }
  }

  return {
    id: faker.string.uuid(),
    garantiaId,
    numeroAveria: `AVE-${faker.number.int({ min: 100000, max: 999999 })}`,
    tipo,
    descripcion: `${tipo}: ${faker.lorem.sentence()}`,
    fechaReporte: fechaReporte.toISOString(),
    estado,
    cubierta,
    motivoRechazo: !cubierta ? faker.helpers.arrayElement([
      'Daño por uso indebido',
      'Mantenimiento no realizado',
      'Desgaste natural',
      'No incluido en cobertura'
    ]) : null,
    costeEstimado: coste,
    costeReal: estado === 'finalizada' || estado === 'facturada' ? coste + faker.number.int({ min: -100, max: 200 }) : null,
    taller: faker.company.name() + ' Taller',
    fechaAutorizacion,
    autorizadoPor,
    evidenciaLegal,
    observaciones: faker.lorem.paragraph()
  };
};

export const generateContrato = () => {
  const fechaInicio = faker.date.past({ years: 2 });
  const fechaFin = new Date(fechaInicio);
  fechaFin.setFullYear(fechaFin.getFullYear() + 1);
  
  return {
    id: faker.string.uuid(),
    numeroContrato: `CON-${faker.number.int({ min: 1000, max: 9999 })}`,
    tipo: faker.helpers.arrayElement(['Marco', 'Específico', 'Anexo']),
    fechaInicio: fechaInicio.toISOString(),
    fechaFin: fechaFin.toISOString(),
    estado: fechaFin > new Date() ? 'vigente' : 'finalizado',
    partes: {
      empresa: 'RD Garantía S.L.',
      cliente: faker.company.name()
    },
    versiones: faker.number.int({ min: 1, max: 5 }),
    ultimaModificacion: faker.date.recent({ days: 30 }).toISOString(),
    anexos: faker.number.int({ min: 0, max: 3 })
  };
};

export const generateFactura = (mes, year) => {
  const averias = faker.number.int({ min: 5, max: 25 });
  const importeTotal = faker.number.int({ min: 2000, max: 15000 });
  const iva = importeTotal * 0.21;
  const retencion = importeTotal * 0.15;
  
  const fecha = new Date(year, mes, 1);
  
  return {
    id: faker.string.uuid(),
    numeroFactura: `FAC-${year}${String(mes + 1).padStart(2, '0')}-${faker.number.int({ min: 100, max: 999 })}`,
    fecha: fecha.toISOString(),
    mes: mes + 1,
    year,
    numeroAverias: averias,
    importeBase: importeTotal,
    iva,
    retencion,
    total: importeTotal + iva - retencion,
    estado: faker.helpers.arrayElement(['pagada', 'pendiente', 'vencida']),
    fechaPago: faker.datatype.boolean(0.7) ? faker.date.recent({ days: 30 }).toISOString() : null,
    metodoPago: 'Transferencia bancaria'
  };
};

export const generateUsuario = (role) => {
  const roles = {
    admin: { email: 'admin@rdgarantia.com', nombre: 'Admin Sistema' },
    agente: { email: 'agente@rdgarantia.com', nombre: 'Carlos Agente' },
    vendedor: { email: 'vendedor@rdgarantia.com', nombre: 'María Vendedor' },
    tecnico: { email: 'tecnico@rdgarantia.com', nombre: 'Juan Técnico' }
  };
  
  const userData = roles[role];
  
  return {
    id: faker.string.uuid(),
    email: userData.email,
    nombre: userData.nombre,
    role,
    avatar: null,
    telefono: `6${faker.number.int({ min: 10000000, max: 99999999 })}`,
    fechaRegistro: faker.date.past({ years: 1 }).toISOString(),
    ultimoAcceso: faker.date.recent({ days: 7 }).toISOString(),
    activo: true
  };
};

export const generateAuditLog = () => {
  const acciones = [
    'login',
    'logout',
    'crear_garantia',
    'editar_garantia',
    'autorizar_averia',
    'rechazar_averia',
    'descargar_certificado',
    'descargar_factura',
    'ver_contrato',
    'subir_documento'
  ];
  
  return {
    id: faker.string.uuid(),
    timestamp: faker.date.recent({ days: 30 }).toISOString(),
    usuario: faker.helpers.arrayElement([
      'admin@rdgarantia.com',
      'agente@rdgarantia.com',
      'vendedor@rdgarantia.com',
      'tecnico@rdgarantia.com'
    ]),
    accion: faker.helpers.arrayElement(acciones),
    entidad: faker.helpers.arrayElement(['garantia', 'averia', 'factura', 'contrato', 'documento']),
    entidadId: faker.string.uuid(),
    ip: faker.internet.ipv4(),
    userAgent: faker.internet.userAgent(),
    detalles: faker.lorem.sentence()
  };
};

export const generateNotificacion = () => {
  const tipos = ['info', 'warning', 'error', 'success'];
  const mensajes = {
    info: [
      'Nueva garantía registrada',
      'Documento subido correctamente',
      'Contrato actualizado'
    ],
    warning: [
      'Garantía próxima a vencer',
      'Factura pendiente de pago',
      'Avería pendiente de autorización'
    ],
    error: [
      'Error al procesar factura',
      'Fallo en integración Bittácora',
      'Documento no encontrado'
    ],
    success: [
      'Avería autorizada correctamente',
      'Pago recibido',
      'Certificado generado'
    ]
  };
  
  const tipo = faker.helpers.arrayElement(tipos);
  
  return {
    id: faker.string.uuid(),
    tipo,
    titulo: faker.helpers.arrayElement(mensajes[tipo]),
    mensaje: faker.lorem.sentence(),
    timestamp: faker.date.recent({ days: 7 }).toISOString(),
    leida: faker.datatype.boolean(0.6),
    entidad: faker.helpers.arrayElement(['garantia', 'averia', 'factura', 'contrato']),
    entidadId: faker.string.uuid()
  };
};

// Configuración del sistema
export const generateConfiguracionSistema = () => {
  return {
    general: {
      nombreEmpresa: 'RD Garantía',
      cif: 'B12345678',
      direccion: 'Calle Principal 123, Madrid',
      telefono: '912345678',
      email: 'info@rdgarantia.com',
      web: 'www.rdgarantia.com',
      logo: null,
      timezone: 'Europe/Madrid',
      idioma: 'es',
      moneda: 'EUR'
    },
    contabilidad: {
      cuentaContableGarantias: '7050000',
      cuentaContableAverias: '6290000',
      cuentaContableProvision: '1430000',
      iva: 21,
      retencionIRPF: 15,
      ejercicioFiscal: new Date().getFullYear(),
      formatoFactura: 'FAC-{YEAR}-{NUMBER}',
      numeracionFacturas: 1,
      diasVencimientoFactura: 30,
      metodoPagoDefecto: 'Transferencia bancaria'
    },
    integraciones: {
      bittacora: {
        activa: true,
        apiUrl: 'https://api.bittacora.com',
        apiKey: 'mock-api-key-bittacora',
        sincronizacionAuto: true,
        ultimaSincronizacion: new Date().toISOString()
      },
      email: {
        activo: true,
        smtp: 'smtp.gmail.com',
        puerto: 587,
        usuario: 'noreply@rdgarantia.com',
        ssl: true
      },
      sms: {
        activo: false,
        proveedor: 'Twilio',
        apiKey: null
      }
    },
    notificaciones: {
      emailGarantiaCreada: true,
      emailAveriaAutorizada: true,
      emailAveriaRechazada: true,
      emailFacturaGenerada: true,
      emailGarantiaProximaVencer: true,
      diasAvisoVencimiento: 30,
      notificacionesInternas: true
    },
    seguridad: {
      sesionExpiracion: 480,
      intentosLoginMax: 5,
      bloqueoTiempo: 30,
      passwordMinLength: 8,
      passwordRequiereNumeros: true,
      passwordRequiereMayusculas: true,
      passwordRequiereEspeciales: true,
      autenticacionDosFactor: false,
      logAuditoria: true,
      retencionLogsAuditoria: 365
    }
  };
};

// Niveles de cobertura
export const generateNivelesCobertura = () => {
  return [
    {
      id: 1,
      nombre: 'Básica',
      descripcion: 'Cobertura básica para componentes esenciales',
      precio: 299,
      coste: 194.35,
      margen: 35,
      duracion: 12,
      kilometrosMax: 150000,
      coberturas: [
        { componente: 'Motor', incluido: true, franquicia: 150 },
        { componente: 'Caja de cambios', incluido: true, franquicia: 150 },
        { componente: 'Sistema eléctrico', incluido: false, franquicia: 0 },
        { componente: 'Suspensión', incluido: false, franquicia: 0 },
        { componente: 'Dirección', incluido: true, franquicia: 100 },
        { componente: 'Frenos', incluido: false, franquicia: 0 },
        { componente: 'Climatización', incluido: false, franquicia: 0 },
        { componente: 'Turbo', incluido: false, franquicia: 0 }
      ],
      serviciosAdicionales: [
        { servicio: 'Asistencia en carretera', incluido: false },
        { servicio: 'Vehículo de sustitución', incluido: false },
        { servicio: 'Gestión de taller', incluido: true }
      ],
      activo: true
    },
    {
      id: 2,
      nombre: 'Estándar',
      descripcion: 'Cobertura completa para uso diario',
      precio: 499,
      coste: 324.35,
      margen: 35,
      duracion: 12,
      kilometrosMax: 200000,
      coberturas: [
        { componente: 'Motor', incluido: true, franquicia: 100 },
        { componente: 'Caja de cambios', incluido: true, franquicia: 100 },
        { componente: 'Sistema eléctrico', incluido: true, franquicia: 100 },
        { componente: 'Suspensión', incluido: true, franquicia: 100 },
        { componente: 'Dirección', incluido: true, franquicia: 50 },
        { componente: 'Frenos', incluido: true, franquicia: 50 },
        { componente: 'Climatización', incluido: false, franquicia: 0 },
        { componente: 'Turbo', incluido: true, franquicia: 150 }
      ],
      serviciosAdicionales: [
        { servicio: 'Asistencia en carretera', incluido: true },
        { servicio: 'Vehículo de sustitución', incluido: false },
        { servicio: 'Gestión de taller', incluido: true }
      ],
      activo: true
    },
    {
      id: 3,
      nombre: 'Premium',
      descripcion: 'Cobertura premium con servicios adicionales',
      precio: 699,
      coste: 454.35,
      margen: 35,
      duracion: 12,
      kilometrosMax: 250000,
      coberturas: [
        { componente: 'Motor', incluido: true, franquicia: 50 },
        { componente: 'Caja de cambios', incluido: true, franquicia: 50 },
        { componente: 'Sistema eléctrico', incluido: true, franquicia: 50 },
        { componente: 'Suspensión', incluido: true, franquicia: 50 },
        { componente: 'Dirección', incluido: true, franquicia: 0 },
        { componente: 'Frenos', incluido: true, franquicia: 0 },
        { componente: 'Climatización', incluido: true, franquicia: 100 },
        { componente: 'Turbo', incluido: true, franquicia: 100 }
      ],
      serviciosAdicionales: [
        { servicio: 'Asistencia en carretera', incluido: true },
        { servicio: 'Vehículo de sustitución', incluido: true },
        { servicio: 'Gestión de taller', incluido: true }
      ],
      activo: true
    },
    {
      id: 4,
      nombre: 'Total',
      descripcion: 'Cobertura total sin franquicias',
      precio: 899,
      coste: 584.35,
      margen: 35,
      duracion: 12,
      kilometrosMax: 300000,
      coberturas: [
        { componente: 'Motor', incluido: true, franquicia: 0 },
        { componente: 'Caja de cambios', incluido: true, franquicia: 0 },
        { componente: 'Sistema eléctrico', incluido: true, franquicia: 0 },
        { componente: 'Suspensión', incluido: true, franquicia: 0 },
        { componente: 'Dirección', incluido: true, franquicia: 0 },
        { componente: 'Frenos', incluido: true, franquicia: 0 },
        { componente: 'Climatización', incluido: true, franquicia: 0 },
        { componente: 'Turbo', incluido: true, franquicia: 0 }
      ],
      serviciosAdicionales: [
        { servicio: 'Asistencia en carretera', incluido: true },
        { servicio: 'Vehículo de sustitución', incluido: true },
        { servicio: 'Gestión de taller', incluido: true }
      ],
      activo: true
    }
  ];
};

// Generar vendedor
const generateVendedor = (id) => {
  const nombres = ['Carlos Ruiz', 'Ana Martínez', 'Pedro Sánchez', 'Laura García', 'Miguel Torres'];
  const emails = ['carlos.ruiz@rdgarantia.com', 'ana.martinez@rdgarantia.com', 'pedro.sanchez@rdgarantia.com', 'laura.garcia@rdgarantia.com', 'miguel.torres@rdgarantia.com'];

  return {
    id: id,
    nombre: nombres[id - 1] || faker.person.fullName(),
    email: emails[id - 1] || faker.internet.email(),
    telefono: faker.phone.number('6## ## ## ##'),
    comision: faker.helpers.arrayElement([3, 4, 5, 6, 7]), // % de comisión
    activo: faker.datatype.boolean(0.9),
    fechaAlta: faker.date.past({ years: 3 }).toISOString().split('T')[0],
    totalVentas: faker.number.int({ min: 50, max: 500 }),
    ventasMesActual: faker.number.int({ min: 5, max: 50 }),
    objetivoMensual: faker.helpers.arrayElement([20, 30, 40, 50]),
    zona: faker.helpers.arrayElement(['Norte', 'Sur', 'Este', 'Oeste', 'Centro']),
    avatar: null
  };
};

// Generar márgenes por nivel de cobertura
const generateMargenes = () => {
  return [
    {
      nivelId: 1,
      nivel: 'Básica',
      precioVenta: 299,
      coste: 194.35,
      margenBruto: 104.65,
      margenPorcentaje: 35,
      comisionVendedor: 3, // % sobre precio venta
      comisionImporte: 8.97
    },
    {
      nivelId: 2,
      nivel: 'Estándar',
      precioVenta: 499,
      coste: 324.35,
      margenBruto: 174.65,
      margenPorcentaje: 35,
      comisionVendedor: 4,
      comisionImporte: 19.96
    },
    {
      nivelId: 3,
      nivel: 'Premium',
      precioVenta: 699,
      coste: 454.35,
      margenBruto: 244.65,
      margenPorcentaje: 35,
      comisionVendedor: 5,
      comisionImporte: 34.95
    },
    {
      nivelId: 4,
      nivel: 'Total',
      precioVenta: 899,
      coste: 584.35,
      margenBruto: 314.65,
      margenPorcentaje: 35,
      comisionVendedor: 6,
      comisionImporte: 53.94
    }
  ];
};

// Generar liquidación mensual para un vendedor
const generateLiquidacionMensual = (vendedorId, mes, year) => {
  const vendedores = ['Carlos Ruiz', 'Ana Martínez', 'Pedro Sánchez', 'Laura García', 'Miguel Torres'];
  const vendedorNombre = vendedores[vendedorId - 1] || 'Vendedor ' + vendedorId;

  // Generar ventas del mes
  const numVentas = faker.number.int({ min: 5, max: 25 });
  const ventas = [];
  let totalComisiones = 0;
  let totalVentas = 0;

  for (let i = 0; i < numVentas; i++) {
    const nivel = faker.helpers.arrayElement([
      { id: 1, nombre: 'Básica', precio: 299, comision: 3 },
      { id: 2, nombre: 'Estándar', precio: 499, comision: 4 },
      { id: 3, nombre: 'Premium', precio: 699, comision: 5 },
      { id: 4, nombre: 'Total', precio: 899, comision: 6 }
    ]);

    const comisionImporte = (nivel.precio * nivel.comision) / 100;

    ventas.push({
      garantiaId: `GAR-${year}-${String(faker.number.int({ min: 1000, max: 9999 }))}`,
      fecha: new Date(year, mes, faker.number.int({ min: 1, max: 28 })).toISOString().split('T')[0],
      cliente: faker.person.fullName(),
      vehiculo: `${faker.vehicle.manufacturer()} ${faker.vehicle.model()}`,
      nivel: nivel.nombre,
      precioVenta: nivel.precio,
      comisionPorcentaje: nivel.comision,
      comisionImporte: parseFloat(comisionImporte.toFixed(2))
    });

    totalComisiones += comisionImporte;
    totalVentas += nivel.precio;
  }

  // Calcular deducciones (averías, devoluciones, etc.)
  const numDeducciones = faker.number.int({ min: 0, max: 3 });
  const deducciones = [];
  let totalDeducciones = 0;

  for (let i = 0; i < numDeducciones; i++) {
    const tipo = faker.helpers.arrayElement(['Avería', 'Devolución', 'Ajuste']);
    const importe = faker.number.float({ min: 10, max: 100, precision: 0.01 });

    deducciones.push({
      tipo: tipo,
      concepto: tipo === 'Avería' ? 'Coste avería no cubierta' : tipo === 'Devolución' ? 'Devolución garantía' : 'Ajuste contable',
      importe: parseFloat(importe.toFixed(2)),
      fecha: new Date(year, mes, faker.number.int({ min: 1, max: 28 })).toISOString().split('T')[0]
    });

    totalDeducciones += importe;
  }

  const comisionNeta = totalComisiones - totalDeducciones;
  const estado = faker.helpers.arrayElement(['pendiente', 'pagada', 'en_revision']);

  return {
    id: `LIQ-${year}${String(mes + 1).padStart(2, '0')}-${vendedorId}`,
    vendedorId: vendedorId,
    vendedorNombre: vendedorNombre,
    mes: mes + 1,
    year: year,
    periodo: `${String(mes + 1).padStart(2, '0')}/${year}`,
    fechaGeneracion: new Date(year, mes + 1, 5).toISOString().split('T')[0],
    fechaPago: estado === 'pagada' ? new Date(year, mes + 1, 10).toISOString().split('T')[0] : null,

    // Resumen
    numeroVentas: numVentas,
    totalVentas: parseFloat(totalVentas.toFixed(2)),
    totalComisionesBrutas: parseFloat(totalComisiones.toFixed(2)),
    totalDeducciones: parseFloat(totalDeducciones.toFixed(2)),
    comisionNeta: parseFloat(comisionNeta.toFixed(2)),

    // Detalle
    ventas: ventas,
    deducciones: deducciones,

    // Estado
    estado: estado,
    observaciones: estado === 'en_revision' ? 'Pendiente de validación de deducciones' : null
  };
};

// Generar alerta para agente comercial
const generateAlerta = (id) => {
  const tipos = [
    { tipo: 'garantia_proxima_vencer', prioridad: 'media', icono: 'AlertCircle' },
    { tipo: 'objetivo_mensual', prioridad: 'alta', icono: 'TrendingUp' },
    { tipo: 'vendedor_bajo_rendimiento', prioridad: 'alta', icono: 'AlertTriangle' },
    { tipo: 'liquidacion_pendiente', prioridad: 'media', icono: 'DollarSign' },
    { tipo: 'averia_pendiente_autorizacion', prioridad: 'alta', icono: 'Wrench' },
    { tipo: 'cliente_insatisfecho', prioridad: 'alta', icono: 'Frown' },
    { tipo: 'renovacion_disponible', prioridad: 'baja', icono: 'RefreshCw' },
    { tipo: 'meta_alcanzada', prioridad: 'baja', icono: 'Award' }
  ];

  const tipoSeleccionado = faker.helpers.arrayElement(tipos);

  const mensajes = {
    'garantia_proxima_vencer': [
      'La garantía GAR-2024-1234 vence en 15 días',
      '5 garantías vencen este mes',
      'Garantía de Juan Pérez vence el 25/02/2024'
    ],
    'objetivo_mensual': [
      'Llevas 15 ventas de 30 este mes (50%)',
      'Objetivo mensual al 75% - ¡Sigue así!',
      'Faltan 5 ventas para alcanzar el objetivo'
    ],
    'vendedor_bajo_rendimiento': [
      'Carlos Ruiz: 3 ventas este mes (objetivo: 20)',
      'Ana Martínez sin ventas en 7 días',
      'Pedro Sánchez por debajo del 40% del objetivo'
    ],
    'liquidacion_pendiente': [
      'Liquidación de enero pendiente de revisión',
      'Tienes 2 liquidaciones pendientes de pago',
      'Liquidación LIQ-202401-3 requiere tu atención'
    ],
    'averia_pendiente_autorizacion': [
      'Avería AVE-2024-567 pendiente de autorización',
      '3 averías esperan tu aprobación',
      'Avería urgente de María López'
    ],
    'cliente_insatisfecho': [
      'Cliente reporta problema con garantía',
      'Valoración negativa de Juan Martínez',
      'Reclamación pendiente de respuesta'
    ],
    'renovacion_disponible': [
      '10 clientes elegibles para renovación',
      'Garantía de Luis García lista para renovar',
      'Oportunidad de renovación: GAR-2023-890'
    ],
    'meta_alcanzada': [
      '¡Objetivo mensual alcanzado!',
      '¡Récord de ventas este mes!',
      '¡100% del objetivo cumplido!'
    ]
  };

  const mensaje = faker.helpers.arrayElement(mensajes[tipoSeleccionado.tipo]);

  return {
    id: `ALERT-${id}`,
    tipo: tipoSeleccionado.tipo,
    prioridad: tipoSeleccionado.prioridad,
    icono: tipoSeleccionado.icono,
    titulo: mensaje,
    mensaje: mensaje,
    fecha: faker.date.recent({ days: 7 }).toISOString(),
    leida: faker.datatype.boolean(0.4),
    accionUrl: tipoSeleccionado.tipo.includes('garantia') ? '/garantias' :
               tipoSeleccionado.tipo.includes('vendedor') ? '/vendedores' :
               tipoSeleccionado.tipo.includes('liquidacion') ? '/liquidaciones' :
               tipoSeleccionado.tipo.includes('averia') ? '/averias' : null,
    accionTexto: tipoSeleccionado.tipo.includes('garantia') ? 'Ver garantía' :
                 tipoSeleccionado.tipo.includes('vendedor') ? 'Ver vendedor' :
                 tipoSeleccionado.tipo.includes('liquidacion') ? 'Ver liquidación' :
                 tipoSeleccionado.tipo.includes('averia') ? 'Ver avería' : 'Ver detalles',
    metadata: {
      garantiaId: tipoSeleccionado.tipo.includes('garantia') ? `GAR-2024-${faker.number.int({ min: 1000, max: 9999 })}` : null,
      vendedorId: tipoSeleccionado.tipo.includes('vendedor') ? faker.number.int({ min: 1, max: 5 }) : null,
      liquidacionId: tipoSeleccionado.tipo.includes('liquidacion') ? `LIQ-202401-${faker.number.int({ min: 1, max: 5 })}` : null,
      averiaId: tipoSeleccionado.tipo.includes('averia') ? `AVE-2024-${faker.number.int({ min: 100, max: 999 })}` : null
    }
  };
};

export const generateMockData = () => {
  const garantias = Array.from({ length: 80 }, (_, i) => generateGarantia());

  const averias = [];
  garantias.forEach(garantia => {
    const numAverias = garantia.numeroAverias;
    for (let i = 0; i < numAverias; i++) {
      averias.push(generateAveria(garantia.id));
    }
  });

  const contratos = Array.from({ length: 12 }, () => generateContrato());

  const facturas = [];
  for (let year = 2023; year <= 2024; year++) {
    for (let mes = 0; mes < 12; mes++) {
      if (year === 2024 && mes > new Date().getMonth()) break;
      facturas.push(generateFactura(mes, year));
    }
  }

  const usuarios = [
    generateUsuario('admin'),
    generateUsuario('agente'),
    generateUsuario('vendedor'),
    generateUsuario('tecnico')
  ];

  const auditLogs = Array.from({ length: 200 }, () => generateAuditLog());
  const notificaciones = Array.from({ length: 50 }, () => generateNotificacion());
  const configuracion = generateConfiguracionSistema();
  const nivelesCobertura = generateNivelesCobertura();

  // Nuevas estructuras para agente comercial
  const vendedores = Array.from({ length: 5 }, (_, i) => generateVendedor(i + 1));
  const margenes = generateMargenes();

  // Generar liquidaciones de los últimos 6 meses
  const liquidaciones = [];
  const currentDate = new Date();
  for (let i = 0; i < 6; i++) {
    const mes = currentDate.getMonth() - i;
    const year = currentDate.getFullYear();
    const mesAjustado = mes < 0 ? 12 + mes : mes;
    const yearAjustado = mes < 0 ? year - 1 : year;

    vendedores.forEach(vendedor => {
      liquidaciones.push(generateLiquidacionMensual(vendedor.id, mesAjustado, yearAjustado));
    });
  }

  // Generar alertas
  const alertas = Array.from({ length: 30 }, (_, i) => generateAlerta(i + 1));

  // Mock de vehículos para autocompletado
  const vehiculosMock = generateVehiculosMock(200);

  // Generar datos para rol cliente
  const clientes = generateClientesMock(garantias);
  const notificacionesCliente = generateNotificacionesMock(clientes);
  const documentosCliente = generateDocumentosMock(clientes);

  return {
    garantias,
    averias,
    contratos,
    facturas,
    usuarios,
    auditLogs,
    notificaciones,
    configuracion,
    nivelesCobertura,
    vendedores,
    margenes,
    liquidaciones,
    alertas,
    vehiculosMock,
    clientes,
    notificacionesClientes: notificacionesCliente,
    documentosCliente
  };
};

// ============================================
// FUNCIONES PARA ROL VENDEDOR
// ============================================

export const generateVehiculosMock = (cantidad = 200) => {
  const vehiculos = [];

  for (let i = 0; i < cantidad; i++) {
    const marca = faker.helpers.arrayElement(Object.keys(marcasModelos));
    const modelo = faker.helpers.arrayElement(marcasModelos[marca]);
    const anio = faker.number.int({ min: 2010, max: 2024 });

    vehiculos.push({
      id: i + 1,
      matricula: generateMatricula(),
      bastidor: generateBastidor(),
      marca,
      modelo,
      version: `${modelo} ${faker.helpers.arrayElement(['1.0', '1.2', '1.4', '1.6', '2.0'])} ${faker.helpers.arrayElement(['TSI', 'TDI', 'HDI', 'TFSI'])}`,
      anio,
      combustible: faker.helpers.arrayElement(combustibles),
      potencia: faker.number.int({ min: 75, max: 250 }),
      cilindrada: faker.number.int({ min: 1000, max: 3000 }),
      color: faker.helpers.arrayElement(colores),
      kilometros: faker.number.int({ min: 5000, max: 200000 }),
      propietario: {
        nombre: faker.person.fullName(),
        telefono: `6${faker.number.int({ min: 10000000, max: 99999999 })}`,
        email: faker.internet.email().toLowerCase()
      }
    });
  }

  return vehiculos;
};

export const calcularRentabilidadVenta = (precioVentaPropio, costeBase) => {
  const rentabilidad = precioVentaPropio - costeBase;
  const porcentaje = ((rentabilidad / precioVentaPropio) * 100).toFixed(2);

  return {
    rentabilidad: parseFloat(rentabilidad.toFixed(2)),
    porcentajeRentabilidad: parseFloat(porcentaje),
    margenBruto: rentabilidad,
    costeBase,
    precioVenta: precioVentaPropio
  };
};

export const calcularProyeccionBeneficios = (garantias, dias = 30) => {
  const fechaLimite = new Date();
  fechaLimite.setDate(fechaLimite.getDate() - dias);

  const ventasRecientes = garantias.filter(g => {
    const fechaAlta = new Date(g.fechaAlta);
    return fechaAlta >= fechaLimite;
  });

  if (ventasRecientes.length === 0) {
    return {
      ventasUltimos30Dias: 0,
      beneficioTotal: 0,
      beneficioPromedioPorVenta: 0,
      proyeccionMensual: 0,
      proyeccionAnual: 0,
      tasaConversion: 0
    };
  }

  const beneficioTotal = ventasRecientes.reduce((sum, g) => sum + (g.rentabilidad || 0), 0);
  const beneficioPromedio = beneficioTotal / ventasRecientes.length;

  const ventasPorDia = ventasRecientes.length / dias;
  const proyeccionMensual = ventasPorDia * 30 * beneficioPromedio;
  const proyeccionAnual = proyeccionMensual * 12;

  return {
    ventasUltimos30Dias: ventasRecientes.length,
    beneficioTotal: parseFloat(beneficioTotal.toFixed(2)),
    beneficioPromedioPorVenta: parseFloat(beneficioPromedio.toFixed(2)),
    ventasPorDia: parseFloat(ventasPorDia.toFixed(2)),
    proyeccionMensual: parseFloat(proyeccionMensual.toFixed(2)),
    proyeccionAnual: parseFloat(proyeccionAnual.toFixed(2)),
    tasaConversion: 100
  };
};

export const buscarVehiculoPorMatricula = (vehiculosMock, matricula) => {
  const matriculaLimpia = matricula.toUpperCase().replace(/[^A-Z0-9]/g, '');
  return vehiculosMock.filter(v =>
    v.matricula.toUpperCase().includes(matriculaLimpia)
  ).slice(0, 10);
};

export const buscarVehiculoPorMarca = (vehiculosMock, marca) => {
  const marcaLimpia = marca.toLowerCase();
  return vehiculosMock.filter(v =>
    v.marca.toLowerCase().includes(marcaLimpia)
  ).slice(0, 10);
};

export const generarFirmaDigital = (tipo = 'certificado_digital') => {
  return {
    firmado: true,
    timestamp: new Date().toISOString(),
    ip: faker.internet.ipv4(),
    hash: Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2),
    metodo: tipo,
    valida: true,
    certificado: tipo === 'certificado_digital' ? {
      emisor: 'FNMT',
      numeroSerie: faker.string.alphanumeric({ length: 16, casing: 'upper' }),
      validoHasta: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString()
    } : null
  };
};

// ============================================
// FUNCIONES PARA ROL TÉCNICO
// ============================================

export const generateDiagnostico = (averiaId) => {
  const piezas = [];
  const numPiezas = faker.number.int({ min: 1, max: 5 });

  for (let i = 0; i < numPiezas; i++) {
    piezas.push({
      id: faker.string.uuid(),
      nombre: faker.helpers.arrayElement([
        'Filtro de aceite',
        'Pastillas de freno',
        'Disco de freno',
        'Amortiguador',
        'Correa de distribución',
        'Bomba de agua',
        'Alternador',
        'Motor de arranque',
        'Batería',
        'Radiador',
        'Termostato',
        'Sensor de temperatura',
        'Bujías',
        'Bobina de encendido',
        'Inyector'
      ]),
      referencia: faker.string.alphanumeric({ length: 10, casing: 'upper' }),
      cantidad: faker.number.int({ min: 1, max: 4 }),
      precioUnitario: faker.number.float({ min: 15, max: 500, precision: 0.01 }),
      proveedor: faker.company.name()
    });
  }

  const costePiezas = piezas.reduce((sum, p) => sum + (p.precioUnitario * p.cantidad), 0);
  const manoDeObra = faker.number.float({ min: 80, max: 400, precision: 0.01 });
  const costeTotal = costePiezas + manoDeObra;

  return {
    id: faker.string.uuid(),
    averiaId,
    descripcion: faker.lorem.paragraph(),
    diagnosticoDetallado: faker.lorem.paragraphs(2),
    piezas,
    manoDeObra,
    costePiezas: parseFloat(costePiezas.toFixed(2)),
    costeTotal: parseFloat(costeTotal.toFixed(2)),
    tiempoEstimado: faker.number.int({ min: 1, max: 8 }),
    timestamp: new Date().toISOString(),
    ip: faker.internet.ipv4(),
    hash: Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2),
    tecnico: faker.helpers.arrayElement(['tecnico@rdgarantia.com', 'mecanico@rdgarantia.com']),
    estado: 'pendiente_aprobacion',
    prioridad: faker.helpers.arrayElement(['baja', 'media', 'alta', 'urgente'])
  };
};

export const generateEvidencia = (averiaId, tipo = 'foto') => {
  const tipos = {
    foto: ['jpg', 'jpeg', 'png'],
    video: ['mp4', 'avi', 'mov'],
    documento: ['pdf', 'doc', 'docx'],
    audio: ['mp3', 'wav', 'ogg']
  };

  const extension = faker.helpers.arrayElement(tipos[tipo] || tipos.foto);
  const filename = `${tipo}_${Date.now()}_${faker.string.alphanumeric({ length: 8 })}.${extension}`;

  return {
    id: faker.string.uuid(),
    averiaId,
    tipo,
    filename,
    rutaLocal: `/uploads/evidencias/${averiaId}/${filename}`,
    rutaPublica: `https://storage.rdgarantia.com/evidencias/${averiaId}/${filename}`,
    tamanio: faker.number.int({ min: 50000, max: 5000000 }),
    hash: Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2),
    timestamp: new Date().toISOString(),
    uploadedBy: faker.helpers.arrayElement(['tecnico@rdgarantia.com', 'mecanico@rdgarantia.com']),
    descripcion: faker.lorem.sentence(),
    metadata: {
      width: tipo === 'foto' ? faker.number.int({ min: 800, max: 4000 }) : null,
      height: tipo === 'foto' ? faker.number.int({ min: 600, max: 3000 }) : null,
      duration: tipo === 'video' || tipo === 'audio' ? faker.number.int({ min: 10, max: 300 }) : null,
      mimeType: `${tipo === 'documento' ? 'application' : tipo}/${extension}`
    }
  };
};

export const generateLiquidacionTecnica = (tecnicoId, mes, year) => {
  const numAverias = faker.number.int({ min: 8, max: 25 });
  const averias = [];

  for (let i = 0; i < numAverias; i++) {
    const coste = faker.number.float({ min: 150, max: 2500, precision: 0.01 });
    const comision = coste * 0.08;

    averias.push({
      averiaId: faker.string.uuid(),
      numeroAveria: `AVE-${faker.number.int({ min: 100000, max: 999999 })}`,
      fecha: faker.date.between({
        from: new Date(year, mes, 1),
        to: new Date(year, mes + 1, 0)
      }).toISOString(),
      tipo: faker.helpers.arrayElement(['Motor', 'Transmisión', 'Suspensión', 'Frenos', 'Eléctrico']),
      coste: parseFloat(coste.toFixed(2)),
      comision: parseFloat(comision.toFixed(2)),
      estado: 'finalizada'
    });
  }

  const totalCoste = averias.reduce((sum, a) => sum + a.coste, 0);
  const totalComision = averias.reduce((sum, a) => sum + a.comision, 0);

  return {
    id: `LIQ-TEC-${year}${String(mes + 1).padStart(2, '0')}-${tecnicoId}`,
    tecnicoId,
    tecnicoNombre: faker.person.fullName(),
    mes: mes + 1,
    year,
    periodo: `${String(mes + 1).padStart(2, '0')}/${year}`,
    fechaGeneracion: new Date().toISOString(),
    fechaPago: null,
    numeroAverias: numAverias,
    totalCoste: parseFloat(totalCoste.toFixed(2)),
    totalComision: parseFloat(totalComision.toFixed(2)),
    averias,
    estado: 'pendiente',
    observaciones: null
  };
};

export const actualizarAveriaDiagnostico = (averia, diagnostico) => {
  return {
    ...averia,
    diagnostico,
    estado: 'diagnosticada',
    costeEstimado: diagnostico.costeTotal,
    fechaDiagnostico: diagnostico.timestamp,
    tecnicoAsignado: diagnostico.tecnico
  };
};

export const agregarEvidenciaAveria = (averia, evidencia) => {
  const evidencias = averia.evidencias || [];

  return {
    ...averia,
    evidencias: [...evidencias, evidencia],
    ultimaActualizacion: new Date().toISOString()
  };
};

// ============================================
// ROL CLIENTE - FUNCIONES Y DATOS MOCK
// ============================================

export const generateCliente = (garantiaId, propietario) => {
  const clienteId = faker.string.uuid();
  const fechaRegistro = faker.date.past({ years: 2 });

  return {
    id: clienteId,
    garantiaId,
    nombre: propietario.nombre,
    dni: propietario.dni,
    email: propietario.email,
    telefono: propietario.telefono,
    direccion: propietario.direccion,
    ciudad: propietario.ciudad,
    codigoPostal: propietario.codigoPostal,
    fechaRegistro: fechaRegistro.toISOString(),
    consentimiento: {
      aceptado: faker.datatype.boolean(0.95),
      fecha: fechaRegistro.toISOString(),
      ip: faker.internet.ipv4(),
      hash: faker.string.alphanumeric({ length: 64 }),
      version: '1.0',
      tipo: 'terminos_y_condiciones'
    },
    preferenciasNotificaciones: {
      email: faker.datatype.boolean(0.9),
      sms: faker.datatype.boolean(0.7),
      push: faker.datatype.boolean(0.6),
      marketing: faker.datatype.boolean(0.4)
    },
    documentosAcceso: [],
    ultimoAcceso: faker.date.recent({ days: 30 }).toISOString(),
    activo: true
  };
};

export const generateNotificacionCliente = (clienteId, tipo = 'general') => {
  const tipos = {
    general: {
      titulo: faker.helpers.arrayElement([
        'Actualización de términos y condiciones',
        'Nuevos servicios disponibles',
        'Mantenimiento programado del sistema',
        'Encuesta de satisfacción'
      ]),
      mensaje: faker.lorem.paragraph(),
      prioridad: 'baja'
    },
    averia: {
      titulo: faker.helpers.arrayElement([
        'Nueva avería registrada',
        'Actualización en el estado de su avería',
        'Avería autorizada para reparación',
        'Reparación completada'
      ]),
      mensaje: faker.lorem.paragraph(),
      prioridad: 'alta'
    },
    garantia: {
      titulo: faker.helpers.arrayElement([
        'Su garantía está próxima a vencer',
        'Renovación de garantía disponible',
        'Documentación de garantía actualizada',
        'Recordatorio de revisión anual'
      ]),
      mensaje: faker.lorem.paragraph(),
      prioridad: 'media'
    },
    documento: {
      titulo: faker.helpers.arrayElement([
        'Nuevo documento disponible',
        'Certificado de garantía actualizado',
        'Factura disponible para descarga',
        'Informe técnico disponible'
      ]),
      mensaje: faker.lorem.paragraph(),
      prioridad: 'media'
    }
  };

  const tipoSeleccionado = tipos[tipo] || tipos.general;
  const fechaCreacion = faker.date.recent({ days: 15 });

  return {
    id: faker.string.uuid(),
    clienteId,
    tipo,
    titulo: tipoSeleccionado.titulo,
    mensaje: tipoSeleccionado.mensaje,
    prioridad: tipoSeleccionado.prioridad,
    leida: faker.datatype.boolean(0.6),
    fechaCreacion: fechaCreacion.toISOString(),
    fechaLectura: faker.datatype.boolean(0.6) ? faker.date.between({
      from: fechaCreacion,
      to: new Date()
    }).toISOString() : null,
    accionRequerida: faker.datatype.boolean(0.3),
    enlace: faker.datatype.boolean(0.5) ? `/cliente/documentos/${faker.string.uuid()}` : null,
    metadata: {
      origen: faker.helpers.arrayElement(['sistema', 'tecnico', 'administrador']),
      relacionadoCon: tipo === 'averia' ? faker.string.uuid() : null
    }
  };
};

export const generateDocumentoCliente = (clienteId, garantiaId, tipo = 'certificado') => {
  const tiposDocumento = {
    certificado: {
      nombre: 'Certificado de Garantía',
      descripcion: 'Certificado oficial de su garantía de vehículo',
      extension: 'pdf',
      categoria: 'garantia'
    },
    factura: {
      nombre: 'Factura de Garantía',
      descripcion: 'Factura de compra de la garantía',
      extension: 'pdf',
      categoria: 'facturacion'
    },
    informe_tecnico: {
      nombre: 'Informe Técnico',
      descripcion: 'Informe técnico de avería',
      extension: 'pdf',
      categoria: 'averia'
    },
    contrato: {
      nombre: 'Contrato de Garantía',
      descripcion: 'Contrato firmado de la garantía',
      extension: 'pdf',
      categoria: 'garantia'
    },
    justificante: {
      nombre: 'Justificante de Reparación',
      descripcion: 'Justificante de reparación autorizada',
      extension: 'pdf',
      categoria: 'averia'
    }
  };

  const tipoDoc = tiposDocumento[tipo] || tiposDocumento.certificado;
  const fechaCreacion = faker.date.recent({ days: 60 });

  return {
    id: faker.string.uuid(),
    clienteId,
    garantiaId,
    tipo,
    nombre: tipoDoc.nombre,
    descripcion: tipoDoc.descripcion,
    filename: `${tipo}_${garantiaId}_${Date.now()}.${tipoDoc.extension}`,
    extension: tipoDoc.extension,
    categoria: tipoDoc.categoria,
    rutaLocal: `/storage/documentos/clientes/${clienteId}/${tipo}_${garantiaId}.${tipoDoc.extension}`,
    rutaPublica: `https://storage.rdgarantia.com/clientes/${clienteId}/${tipo}_${garantiaId}.${tipoDoc.extension}`,
    tamanio: faker.number.int({ min: 100000, max: 2000000 }),
    hash: faker.string.alphanumeric({ length: 64 }),
    fechaCreacion: fechaCreacion.toISOString(),
    fechaExpiracion: tipo === 'certificado' ? faker.date.future({ years: 1 }).toISOString() : null,
    descargas: faker.number.int({ min: 0, max: 10 }),
    ultimaDescarga: faker.datatype.boolean(0.7) ? faker.date.between({
      from: fechaCreacion,
      to: new Date()
    }).toISOString() : null,
    visible: true,
    protegido: true
  };
};

export const consultarGarantia = (clienteId, clientesMock, garantiasMock) => {
  const cliente = clientesMock.find(c => c.id === clienteId);

  if (!cliente) {
    return {
      success: false,
      message: 'Cliente no encontrado',
      data: null
    };
  }

  const garantia = garantiasMock.find(g => g.id === cliente.garantiaId);

  if (!garantia) {
    return {
      success: false,
      message: 'Garantía no encontrada',
      data: null
    };
  }

  const fechaActual = new Date();
  const fechaVencimiento = new Date(garantia.fechaVencimiento);
  const diasRestantes = Math.ceil((fechaVencimiento - fechaActual) / (1000 * 60 * 60 * 24));
  const vigente = fechaVencimiento > fechaActual;
  const proximaVencer = vigente && diasRestantes <= 30;

  const coberturas = {
    1: {
      nivel: 'Básica',
      componentes: ['Motor', 'Caja de cambios'],
      servicios: ['Asistencia en carretera 24h'],
      franquicia: 150
    },
    2: {
      nivel: 'Estándar',
      componentes: ['Motor', 'Caja de cambios', 'Sistema eléctrico', 'Suspensión'],
      servicios: ['Asistencia en carretera 24h', 'Vehículo de sustitución (3 días)'],
      franquicia: 100
    },
    3: {
      nivel: 'Premium',
      componentes: ['Motor', 'Caja de cambios', 'Sistema eléctrico', 'Suspensión', 'Dirección', 'Frenos', 'Climatización'],
      servicios: ['Asistencia en carretera 24h', 'Vehículo de sustitución (7 días)', 'Gestión de taller'],
      franquicia: 50
    },
    4: {
      nivel: 'Total',
      componentes: ['Motor', 'Caja de cambios', 'Sistema eléctrico', 'Suspensión', 'Dirección', 'Frenos', 'Climatización', 'Turbo', 'Sistema de inyección'],
      servicios: ['Asistencia en carretera 24h', 'Vehículo de sustitución (15 días)', 'Gestión de taller', 'Recogida y entrega a domicilio'],
      franquicia: 0
    }
  };

  const cobertura = coberturas[garantia.nivel];

  return {
    success: true,
    message: 'Garantía consultada correctamente',
    data: {
      garantia: {
        id: garantia.id,
        numeroGarantia: garantia.numeroGarantia,
        nivel: garantia.nivel,
        nivelNombre: garantia.nivelNombre,
        fechaAlta: garantia.fechaAlta,
        fechaVencimiento: garantia.fechaVencimiento,
        estado: garantia.estado,
        vigente,
        diasRestantes: vigente ? diasRestantes : 0,
        proximaVencer
      },
      vehiculo: {
        matricula: garantia.vehiculo.matricula,
        marca: garantia.vehiculo.marca,
        modelo: garantia.vehiculo.modelo,
        version: garantia.vehiculo.version,
        year: garantia.vehiculo.year,
        combustible: garantia.vehiculo.combustible,
        kilometros: garantia.vehiculo.kilometros
      },
      cobertura: {
        nivel: cobertura.nivel,
        componentesCubiertos: cobertura.componentes,
        serviciosIncluidos: cobertura.servicios,
        franquicia: cobertura.franquicia,
        duracion: '12 meses',
        kilometrosMaximos: 'Sin límite'
      },
      estadisticas: {
        numeroAverias: garantia.numeroAverias || 0,
        averiasActivas: 0,
        ultimaRevision: garantia.fechaAlta
      }
    }
  };
};

export const verificarAccesoDocumento = (clienteId, documentoId, documentosMock) => {
  const documento = documentosMock.find(d => d.id === documentoId);

  if (!documento) {
    return {
      success: false,
      message: 'Documento no encontrado',
      tieneAcceso: false
    };
  }

  if (documento.clienteId !== clienteId) {
    return {
      success: false,
      message: 'No tiene permisos para acceder a este documento',
      tieneAcceso: false
    };
  }

  if (!documento.visible) {
    return {
      success: false,
      message: 'Documento no disponible',
      tieneAcceso: false
    };
  }

  return {
    success: true,
    message: 'Acceso autorizado',
    tieneAcceso: true,
    documento
  };
};

export const registrarDescargaDocumento = (documentoId, documentosMock) => {
  const documento = documentosMock.find(d => d.id === documentoId);

  if (!documento) {
    return {
      success: false,
      message: 'Documento no encontrado'
    };
  }

  documento.descargas = (documento.descargas || 0) + 1;
  documento.ultimaDescarga = new Date().toISOString();

  return {
    success: true,
    message: 'Descarga registrada',
    data: {
      descargas: documento.descargas,
      ultimaDescarga: documento.ultimaDescarga
    }
  };
};

export const actualizarConsentimientoCliente = (clienteId, consentimiento, clientesMock) => {
  const cliente = clientesMock.find(c => c.id === clienteId);

  if (!cliente) {
    return {
      success: false,
      message: 'Cliente no encontrado'
    };
  }

  cliente.consentimiento = {
    ...cliente.consentimiento,
    aceptado: consentimiento.aceptado,
    fecha: new Date().toISOString(),
    ip: consentimiento.ip || faker.internet.ipv4(),
    hash: faker.string.alphanumeric({ length: 64 }),
    version: consentimiento.version || '1.0',
    tipo: consentimiento.tipo || 'terminos_y_condiciones',
    observaciones: consentimiento.observaciones || null
  };

  return {
    success: true,
    message: 'Consentimiento actualizado correctamente',
    data: cliente.consentimiento
  };
};

export const marcarNotificacionLeida = (notificacionId, notificacionesMock) => {
  const notificacion = notificacionesMock.find(n => n.id === notificacionId);

  if (!notificacion) {
    return {
      success: false,
      message: 'Notificación no encontrada'
    };
  }

  notificacion.leida = true;
  notificacion.fechaLectura = new Date().toISOString();

  return {
    success: true,
    message: 'Notificación marcada como leída',
    data: notificacion
  };
};

export const getAveriasCliente = (clienteId, clientesMock, averiasMock) => {
  const cliente = clientesMock.find(c => c.id === clienteId);

  if (!cliente) {
    return {
      success: false,
      message: 'Cliente no encontrado',
      data: []
    };
  }

  const averiasCliente = averiasMock.filter(a => a.garantiaId === cliente.garantiaId);

  const averiasFormateadas = averiasCliente.map(averia => ({
    id: averia.id,
    numeroAveria: averia.numeroAveria,
    tipo: averia.tipo,
    descripcion: averia.descripcion,
    estado: averia.estado,
    fechaReporte: averia.fechaReporte,
    fechaAutorizacion: averia.fechaAutorizacion,
    cubierta: averia.cubierta,
    costeEstimado: averia.costeEstimado,
    taller: averia.taller,
    diagnostico: averia.diagnostico ? {
      descripcion: averia.diagnostico.descripcion,
      coste: averia.diagnostico.coste,
      timestamp: averia.diagnostico.timestamp
    } : null,
    tieneEvidencias: averia.evidencias && averia.evidencias.length > 0,
    numeroEvidencias: averia.evidencias ? averia.evidencias.length : 0
  }));

  return {
    success: true,
    message: 'Averías consultadas correctamente',
    data: averiasFormateadas
  };
};

export const generateClientesMock = (garantiasMock) => {
  const clientes = [];

  garantiasMock.forEach((garantia, index) => {
    const cliente = generateCliente(garantia.id, garantia.propietario);

    // El primer cliente será el usuario de prueba
    if (index === 0) {
      cliente.email = 'cliente@rdgarantia.com';
      cliente.nombre = 'Juan Pérez García';
      cliente.dni = '12345678A';
      cliente.telefono = '612345678';
      cliente.direccion = 'Calle Principal 123';
      cliente.ciudad = 'Madrid';
      cliente.codigoPostal = '28001';
    }

    clientes.push(cliente);
  });

  return clientes;
};

export const generateNotificacionesMock = (clientesMock) => {
  const notificaciones = [];

  clientesMock.forEach(cliente => {
    const numNotificaciones = faker.number.int({ min: 3, max: 10 });

    for (let i = 0; i < numNotificaciones; i++) {
      const tipo = faker.helpers.arrayElement(['general', 'averia', 'garantia', 'documento']);
      notificaciones.push(generateNotificacionCliente(cliente.id, tipo));
    }
  });

  return notificaciones;
};

export const generateDocumentosMock = (clientesMock) => {
  const documentos = [];

  clientesMock.forEach(cliente => {
    documentos.push(generateDocumentoCliente(cliente.id, cliente.garantiaId, 'certificado'));
    documentos.push(generateDocumentoCliente(cliente.id, cliente.garantiaId, 'contrato'));
    documentos.push(generateDocumentoCliente(cliente.id, cliente.garantiaId, 'factura'));

    if (faker.datatype.boolean(0.4)) {
      documentos.push(generateDocumentoCliente(cliente.id, cliente.garantiaId, 'informe_tecnico'));
    }

    if (faker.datatype.boolean(0.3)) {
      documentos.push(generateDocumentoCliente(cliente.id, cliente.garantiaId, 'justificante'));
    }
  });

  return documentos;
};
